import { render, staticRenderFns } from "./CustomFieldRemove.vue?vue&type=template&id=53f9bac2&scoped=true&lang=pug&"
import script from "./CustomFieldRemove.vue?vue&type=script&lang=js&"
export * from "./CustomFieldRemove.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldRemove.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./CustomFieldRemove.vue?vue&type=style&index=1&id=53f9bac2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f9bac2",
  null
  
)

export default component.exports